<div class="folders-header">
  <div class="folder-toolbar">
    <div class="folder-toolbar__actions">
      <button mat-raised-button color="accent" (click)="openNewSourceModal()"><mat-icon>add</mat-icon>Upload</button>
      <button mat-stroked-button color="primary" (click)="goToBatchUpload()"><mat-icon>upload_file</mat-icon>Batch Upload</button>
      <button mat-stroked-button color="primary" (click)="openEditModal()">Edit Folder</button>
      <button mat-icon-button class="approval-button" [class.approved]="selectedItem.approved" (click)="toggleApproval()" [disabled]="isApprovingFolder" matTooltip="{{ selectedItem.approved ? 'Approved' : 'Not Approved' }}" aria-label="Toggle folder approval" >
        <mat-icon>{{ selectedItem.approved ? 'check_circle' : 'check_circle_outline' }}</mat-icon>
      </button>
    </div>
    <div class="d-flex align-items-center">
      <app-job-status [folder]="selectedItem"></app-job-status>
      @if (isLoading) { <mat-progress-spinner class="spinner" [color]="'accent'" [mode]="'indeterminate'" [value]="50"></mat-progress-spinner> }
    </div>
  </div>
  <app-folder-sources-list [paging]="paging" [isLoading]="isLoading" [folder]="selectedItem" [folderSources]="folderSources" [sorting]="sorting" (sourceSelected)="handleSourceSelected($event)" (sortChanged)="handleSortChange($event)" (pageChanged)="handlePageChange($event)"></app-folder-sources-list>
</div>
